import { ButtonHTMLAttributes, forwardRef } from 'react';
import { cn } from '@/lib/utils/cn';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg';
}

const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    { variant = 'primary', size = 'md', className, children, ...props },
    ref
  ) => {
    const baseStyles =
      'inline-flex items-center justify-center rounded-chart font-display font-semibold uppercase tracking-[0.14em] transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed';

    const variants = {
      primary: 'bg-beacon text-vellum hover:bg-beacon-deep',
      secondary: 'bg-ink text-vellum hover:bg-ink-soft',
      outline:
        'border border-rule text-ink hover:border-beacon hover:text-beacon',
    };

    const sizes = {
      sm: 'px-4 py-2 text-xs',
      md: 'px-7 py-3 text-sm',
      lg: 'px-9 py-4 text-base',
    };

    return (
      <button
        ref={ref}
        className={cn(baseStyles, variants[variant], sizes[size], className)}
        {...props}
      >
        {children}
      </button>
    );
  }
);

Button.displayName = 'Button';

export { Button };
